<script>
import { Doughnut } from "vue-chartjs";
import { mapGetters } from "vuex";

export default {
  extends: Doughnut,
  props: ["view"],
  data() {
    return {
      chartData: {
        datasets: [
          {
            borderWidth: 1,
            borderColor: [
              "#4C53BD",
              "#F56B68",
              "#2CD494",
              "#F8D9AF",

              "#4FC3F7",
              "#5C6BC0",
              "#1E88E5",
              "#26A69A",
              "#00ACC1",
              "#B39DDB",
              "#C5CAE9",
              "#FFCCBC",
              "#8D6E63",
              "#FFB74D",
              "#B2EBF2",
              "#F0F4C3",
              "#FF8A80",
              "#E1BEE7",
              "#F8BBD0",
              "#8C9EFF",
              "#81D4FA",
            ],
            backgroundColor: [
              "#4C53BD",
              "#F56B68",
              "#2CD494",
              "#F8D9AF",
              "#4FC3F7",
              "#5C6BC0",
              "#1E88E5",
              "#26A69A",
              "#00ACC1",
              "#B39DDB",
              "#C5CAE9",
              "#FFCCBC",
              "#8D6E63",
              "#FFB74D",
              "#B2EBF2",
              "#F0F4C3",
              "#FF8A80",
              "#E1BEE7",
              "#F8BBD0",
              "#8C9EFF",
              "#81D4FA",
            ],
            hoverBorderWidth: 10,
          },
        ],
      },
      options: {
        tooltips: {
          backgroundColor: "#DCD8F3",
        },
        legend: {
          display: false,
          position: "right",
          labels: {
            usePointStyle: true,
            boxWidth: 6,
            pointStyle: "circle",
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      chartDummyData: {
        datasets: [
          {
            borderWidth: 1,
            borderColor: ["#F3F3F3"],
            backgroundColor: ["#F3F3F3"],
            hoverBorderWidth: 1,
            data: [1000],
          },
        ],
      },
      dummyOptions: {
        tooltips: {
          enabled: false,
          backgroundColor: "#F3F3F3",
        },
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  computed: {
    ...mapGetters(["getProject", "getTopDepartments"]),
  },
  methods: {
    updateDonut() {
      let allDepartmentsHaveZeroScore = this.getTopDepartments.find((item) => {
        return item.score != 0;
      });
      if (allDepartmentsHaveZeroScore) {
        this.chartData.labels = this.getTopDepartments
          .filter((item) => {
            return item.score;
          })
          .map((dep) => dep.department);
        this.chartData.datasets[0].data = this.getTopDepartments
          .filter((item) => {
            return item.score;
          })
          .map((dep) => dep.score);
        this.sliceView();
        this.renderChart(this.chartData, this.options);
      } else {
        this.renderChart(this.chartDummyData, this.dummyOptions);
      }
    },
    sliceView() {
      let allDepartmentsHaveZeroScore = this.getTopDepartments.find((item) => {
        return item.score != 0;
      });
      if (allDepartmentsHaveZeroScore) {
        if (this.view) {
          this.chartData.labels = this.getTopDepartments
            .filter((item) => {
              return item.score;
            })
            .map((dep) => dep.department)
            .slice(0, this.view);
          this.chartData.datasets[0].data = this.getTopDepartments
            .filter((item) => {
              return item.score;
            })
            .map((dep) => dep.score)
            .slice(0, this.view);
          this.renderChart(this.chartData, this.options);
        } else {
          this.chartData.labels = this.getTopDepartments
            .filter((item) => {
              return item.score;
            })
            .map((dep) => dep.department);
          this.chartData.datasets[0].data = this.getTopDepartments
            .filter((item) => {
              return item.score;
            })
            .map((dep) => dep.score);
          this.renderChart(this.chartData, this.options);
        }
      } else {
        this.renderChart(this.chartDummyData, this.dummyOptions);
      }
    },
    randomBackgroundColor(seed, colors) {
      return colors[seed % colors.length];
    },
  },
  watch: {
    view() {
      this.sliceView();
    },
    getTopDepartments() {
      this.updateDonut();
    },
  },
  mounted() {
    this.updateDonut();
  },
};
</script>
